import React from 'react';
import { Box, MenuItem, TextField, Typography } from '@mui/material';
import { getAuthGlassFieldSx } from '../Auth/authGlassStyles';
import { LISTING_STATUS_LABELS } from './listingDisplayStatus';

const MLS_STATUS_OPTIONS = [
  'active',
  'pending',
  'sold',
  'withdrawn',
  'expired',
  'unknown',
];

/** Read-only MLS property status dropdown — disabled; fed by MLS webhooks when sync is on. */
const MlsPropertyStatusField = ({ value = 'unknown', mlsSyncEnabled = false, theme }) => {
  const fieldSx = getAuthGlassFieldSx(theme);
  const normalized = MLS_STATUS_OPTIONS.includes(value) ? value : 'unknown';

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        component="label"
        sx={{
          display: 'block',
          fontSize: '14px',
          fontWeight: 500,
          color: 'rgba(0,0,0,0.55)',
          mb: 0.75,
        }}
      >
        Property status (MLS)
      </Typography>
      <TextField
        select
        fullWidth
        value={normalized}
        disabled
        helperText={
          mlsSyncEnabled
            ? 'Synced from your MLS feed while MLS sync is on for this listing.'
            : 'Updates from your MLS feed when you turn on MLS sync for this listing.'
        }
        sx={fieldSx}
      >
        {MLS_STATUS_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {LISTING_STATUS_LABELS[option]}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default MlsPropertyStatusField;
